import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Wrapper, Header, Title, Text, Paragraph} from '../Modal/modal.style';
import {Button} from '../../styles/components/button.style';

export class TableBookingModal extends PureComponent {
  render() {
    const {closeModalCallback} = this.props;

    return (
      <Wrapper>
        <Header>
          <Title data-rw="basket-modal--meal-title"><FormattedMessage id="booking.requestSent" /></Title>
        </Header>
        <Paragraph left>
          <Text><FormattedMessage id="booking.confirmation1" /></Text>
          <Text><FormattedMessage id="booking.confirmation2" /></Text>
        </Paragraph>
        <Button onClick={closeModalCallback}><FormattedMessage id="modal.close" /></Button>
      </Wrapper>
    );
  }
}

TableBookingModal.propTypes = {
  closeModalCallback: PropTypes.func
};

export default TableBookingModal;



// WEBPACK FOOTER //
// ./components/ModalContent/TableBookModal.js